import Navbar from '@/views/components/layouts/Navbar.vue';
import MainCategory from '@/views/pages/products/category/main/Index.vue';
import SubCategory from '@/views/pages/products/category/sub/Index.vue';

export default {
  components: {
    Navbar,
    MainCategory,
    SubCategory
  },
  data: () => ({
    tab: null
  })
};
